import Vue from 'vue'
import Vuex from 'vuex'
import vuexCache from 'vuex-cache'
import cleaningLogs from './modules/cleaning-logs'
import assignment from './modules/assignment'
import cleaning from './modules/cleaning'
import cleanerHistory from './modules/cleaner-history'
import cleanerEvents from './modules/cleaner-events'
import vrms from './modules/vrms'
import mrs from './modules/mrs'
import workshop from './modules/workshop'
import vmts from './modules/vmts'
import cocos from './modules/cocos'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    assignment,
    cleaning,
    cleaningLogs,
    cleanerHistory,
    cleanerEvents,
    vrms,
    mrs,
    workshop,
    vmts,
    cocos
  },
  plugins: [vuexCache({ timeout: 300000 })], // 10 mins
  strict: debug
})
